import type { FieldADTValue, SchemaProtocol } from '@lighthouse/core'

import type { DeptOption, RoleOption, UserOption } from '../../../../types'
import { fieldConvertValue, findRecordInPool, type RecordPoolMap } from '../../../../utils'

interface getConvertValueParams {
    recordId: string
    dsId: string
    fieldId: string
    /** recordPool 使用 Map 结构 */
    records: RecordPoolMap
    schema: SchemaProtocol['schema']
    roleOptions: RoleOption[]
    departmentOptions: DeptOption[]
    personOptions: UserOption[]
    isReallyNumber?: boolean
}

export function getConvertValue(params: getConvertValueParams) {
    const { recordId, dsId, fieldId, records, schema, personOptions, roleOptions, departmentOptions, isReallyNumber = true } = params
    //  使用 Map 的 O(1) 查找
    const record = findRecordInPool(records, dsId, recordId)
    if (!record || !schema) {
        return null
    }
    const value = record?.content?.[fieldId]?.value || ''
    const fieldValue = {
        ...schema[fieldId],
        value
    } as FieldADTValue
    return fieldConvertValue(fieldValue, { personOptions, roleOptions, departmentOptions, isReallyNumber })
}
